import { render, staticRenderFns } from "./awsServers.vue?vue&type=template&id=626aabe7&"
import script from "./awsServers.vue?vue&type=script&lang=js&"
export * from "./awsServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports